import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Container,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import { IClientTable, IClientTableRedux, ITarget } from '../../types/interfaces';

import ClientEdit from './ClientEdit';
import ClientDelete from './ClientDelete';
import { getFtpScan } from '../../flux/actions/clientActions';
import TableContainer from "../tables_manager/TableContainer"
import { DateRangeColumnFilter, SelectColumnFilter } from '../tables_manager/filters';
import EditableCell from "../tables_manager/EditableCell";
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faClipboard, faExternalLinkAlt, faIdCard, faPen, faPhone, faPrint, faSearch } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import moment from "moment";
import LinesEllipsis from 'react-lines-ellipsis'
import Loading from '../Loading';
import ReactTooltip from 'react-tooltip';
import PDFLink from '../pdf/PDFLink';
import ClientScanModal from './ClientScanModal';
import { getNationality } from '../../services/misc';

const ClientTable = ({ 
  clientsData,
  setTableData,
 }: IClientTable) => {
  const history = useHistory();
  const alert = useAlert();
  const [modal, setModal] = useState(false);
  const [modalDelete, setModalDelete] = useState(false);
  const [modalScan, setModalScan] = useState(false);
  const [modalClient, setModalClient] = useState('');
  const [modalDeleteClient, setModalDeleteClient] = useState('');
  const [modalScanClient, setModalScanClient] = useState('');
  const [CINImg, setCINImg] = useState('');
  const [passportImg, setPassportImg] = useState('');
  const [CINLoading, setCINLoading] = useState(false);
  const [passportLoading, setPassportLoading] = useState(false);
  const [imagesCache, setImagesCache] = useState<any[]>([]);

  const [copiedFlag, setCopiedFlag] = useState(false);
  const [copiedFlag2, setCopiedFlag2] = useState(false);
  const handleCopy = (e, id = 1) => {
    let phone = (e || "").toString().replace(/ /g,'');
    if(phone.length >= 4 && phone[0] !== "0")
      phone = "+" + phone
    alert.info(`Le numéro de téléphone "${phone}" a été copié.`);
    window.navigator.clipboard.writeText(phone);
    if(id == 1){
      setCopiedFlag(true);
      setTimeout(() => setCopiedFlag(false), 2000);
    }
    else if(id == 2){
      setCopiedFlag2(true);
      setTimeout(() => setCopiedFlag2(false), 2000);
    }
  };
  
  const handleToggleDelete = () => setModalDelete(!modalDelete);

  const columns = useMemo(
    () => [
      {
        Header: "ID client",
        accessor: "id",
        Cell: ({ value }) => {
          return value ||"-"
          return (<a href={value !== null && value !== undefined ? (`/fiche_client/${value}`) : '/#'} onClick={(e) => {
            e.preventDefault();
            if(value !== null && value !== undefined){
              if (e.ctrlKey){
                window.open('/fiche_client/' + value,'_blank');
                return;
              }
              history.push({ pathname: `/fiche_client/${value}` })
            }
            else
              alert.error(E_ERROR.NO_CLIENT_WITH_THIS_ID)
          }}><button className="openLinkBtn">{value}<FontAwesomeIcon icon={faExternalLinkAlt} className="openLinkIcon" /></button></a>)
        },
        hidden: true
      },
      {
        Header: "Civilité",
        accessor: "CIVILITE",
        Filter: SelectColumnFilter,
        Cell: ({ value }) => value || "-",
        // hidden: true
      },
      {
        Header: "Nom complet",
        accessor: "nom_complet",
        filter: (rows, id, e) => rows.filter(t => (e || "").split(" ").length === 2 ? 
        ((t.original.NOM?.toString().toLowerCase().includes((e || "").toLowerCase().split(" ")[0]) && t.original.PRENOM?.toString().toLowerCase().includes((e || "").toLowerCase().split(" ")[1])) || (t.original.PRENOM?.toString().toLowerCase().includes((e || "").toLowerCase().split(" ")[0]) && t.original.NOM?.toString().toLowerCase().includes((e || "").toLowerCase().split(" ")[1])))
         : (e || "").toLowerCase().split(" ").filter(n => t.original.NOM?.toString().toLowerCase().includes(n) || t.original.PRENOM?.toString().toLowerCase().includes(n)).length > 0),
        // filter: (rows, id, e) => rows.filter(t => t.original.NOM?.toString().toLowerCase().includes((e || "").toLowerCase()) || t.original.PRENOM?.toString().toLowerCase().includes((e || "").toLowerCase())),
        Cell: ({ row: {original} }) => `${original.NOM || "-"} ${original.PRENOM || ""}`
      },
      {
        Header: "CIN/Passeport",
        accessor: e => e.PASSPORT || e.CIN || "",
        Cell: ({ value }) => {
          return (<div className="fullFlexCenter">
            {value || "-"}
            {!!value && <FontAwesomeIcon icon={faSearch} title="Chercher dans les biens vendus" className="cinLookupIcon" onClick={e => {
              if (e.ctrlKey){
                window.open("/consultation?cp=" + value, '_blank');
                return;
              }
              history.push({ pathname: `/consultation`, search: "?cp=" + value})
            }} />}
          </div>)
        }
      },
      // {
      //   Header: "CIN/Passeport",
      //   accessor: "cin_passport",
      //   filter: (rows, id, e) => rows.filter(t => t.original.CIN?.toString().toLowerCase().includes((e || "").toLowerCase()) || t.original.PASSPORT?.toString().toLowerCase().includes((e || "").toLowerCase())),
      //   // Cell: ({ row: {original} }) => original.PASSPORT || original.CIN || "-",
      //   Cell: ({ row: {original} }) => {
      //     return (<div className="fullFlexCenter">
      //       {original.PASSPORT || original.CIN || "-"}
      //       {!!(original.PASSPORT || original.CIN) && <FontAwesomeIcon icon={faSearch} title="Chercher dans les biens vendus" style={{cursor: "pointer", marginLeft: 5, color: "green"}} onClick={e => {
      //         if (e.ctrlKey){
      //           window.open("/consultation?cp=" + (original.PASSPORT || original.CIN), '_blank');
      //           return;
      //         }
      //         history.push({ pathname: `/consultation`, search: "?cp=" + (original.PASSPORT || original.CIN) })
      //       }} />}
      //     </div>)
      //   }
      // },
      {
        Header: "Date CIN",
        accessor: "DATE_CIN",
        customExportDisplay: `$.DATE_CIN ? new Date($.DATE_CIN) : "-"`,
        Filter: DateRangeColumnFilter,
        filter: "dateBetween",
        // filter: (rows, id, e) => rows.filter(t => t.original[id] && moment(t.original[id]).format('DD/MM/YYYY').includes(e)),
        Cell: ({ value }) => value ? moment(value).format('DD/MM/YYYY') : "-",
        hidden: true
      },
      {
        Header: "Numéro(s) de Téléphone",
        accessor: "TEL",
        disableSortBy: true,
        Cell: ({ row }) => row.original.TEL || row.original.TEL2 ? <div>
          {row.original.TEL ? <div style={{whiteSpace: "nowrap"}}>
            {row.original.TEL.length >= 4 && row.original.TEL[0] !== "0" ? ("+" + row.original.TEL) : row.original.TEL}
            <a data-tip data-for="telI" href={`tel:${(row.original.TEL.length >= 4 && row.original.TEL[0] !== "0" ? ("+" + row.original.TEL) : row.original.TEL).replace(/ /g,'')}`} style={{marginLeft: "5px", marginRight: "10px"}}><FontAwesomeIcon icon={faPhone} /></a>
            <ReactTooltip effect="solid" place="bottom" id="telI" type="dark"><b>Appeler</b></ReactTooltip>
            <FontAwesomeIcon icon={faClipboard} data-tip data-for="tel" style={{cursor: "pointer"}} onClick={() => handleCopy(row.original.TEL)} />
            <ReactTooltip effect="solid" place="bottom" id="tel" type={copiedFlag ? "success" : "dark"}>
              <FontAwesomeIcon icon={copiedFlag ? faCheckCircle : faClipboard} />&nbsp;&nbsp;{copiedFlag ? "Copié" : "Copier"}
            </ReactTooltip>
          </div> : null}
          {row.original.TEL2 ? <div style={{whiteSpace: "nowrap"}}>
            {row.original.TEL2.length >= 4 && row.original.TEL2[0] !== "0" ? ("+" + row.original.TEL2) : row.original.TEL2}
            <a data-tip data-for="telI2" href={`tel:${(row.original.TEL2.length >= 4 && row.original.TEL2[0] !== "0" ? ("+" + row.original.TEL2) : row.original.TEL2).replace(/ /g,'')}`} style={{marginLeft: "5px", marginRight: "10px"}}><FontAwesomeIcon icon={faPhone} /></a>
            <ReactTooltip effect="solid" place="bottom" id="telI2" type="dark"><b>Appeler</b></ReactTooltip>
            <FontAwesomeIcon icon={faClipboard} data-tip data-for="tel2" style={{cursor: "pointer"}} onClick={() => handleCopy(row.original.TEL2, 2)} />
            <ReactTooltip effect="solid" place="bottom" id="tel2" type={copiedFlag2 ? "success" : "dark"}>
              <FontAwesomeIcon icon={copiedFlag2 ? faCheckCircle : faClipboard} />&nbsp;&nbsp;{copiedFlag2 ? "Copié" : "Copier"}
            </ReactTooltip>
          </div> : null}
        </div> : "-"
      },
      {
        Header: "Email",
        accessor: "MAIL",
        Cell: ({ value }) => value || "-",
        hidden: true
      },
      {
        Header: "Adresse",
        accessor: "ADRESSE",
        Cell: ({ value }) => value || "-"
      },
      {
        Header: "Ville",
        accessor: "VILLE",
        Cell: ({ value }) => value || "-"
      },
      {
        Header: "Pays",
        accessor: "PAYS",
        Cell: ({ value }) => value || "-",
        hidden: true
      },
      {
        Header: "Nationalité",
        accessor: e => getNationality(e.NATIONALITE),
        Cell: ({ value }) => value || "-",
        hidden: true
      },
      {
        Header: "Date de naissance",
        accessor: "DATE_NAISS",
        customExportDisplay: `$.DATE_NAISS ? new Date($.DATE_NAISS) : "-"`,
        Filter: DateRangeColumnFilter,
        filter: "dateBetween",
        // filter: (rows, id, e) => rows.filter(t => t.original[id] && moment(t.original[id]).format('DD/MM/YYYY').includes(e)),
        Cell: ({ value }) => value ? moment(value).format('DD/MM/YYYY') : "-"
      },
      {
        Header: "Lieu de naissance",
        accessor: "LIEU_NAISS",
        Cell: ({ value }) => value || "-",
        hidden: true
      },
      {
        Header: "Situation familiale",
        accessor: "SITUATION_FAM",
        Filter: SelectColumnFilter,
        Cell: ({ value }) => value || "-",
        hidden: true
      },
      {
        Header: "Nombre d'enfants",
        accessor: "NBR_ENFANT",
        Cell: ({ value }) => value || "-",
        hidden: true
      },
      {
        Header: "Fonction",
        accessor: "PROFESSION",
        Cell: ({ value }) => value || "-",
        hidden: true
      },
      {
        Header: "Type Fonction",
        accessor: "TYPE_PROFESSION",
        Filter: SelectColumnFilter,
        Cell: ({ value }) => value || "-",
        hidden: true
      },
      {
        Header: "Support publicitaire",
        accessor: "SUPPORT_PUB",
        Cell: ({ value }) => value || "-",
        hidden: true
      },
      {
        Header: "Date Publicité",
        accessor: "DATE_PUB",
        customExportDisplay: `$.DATE_PUB ? new Date($.DATE_PUB) : "-"`,
        Filter: DateRangeColumnFilter,
        filter: "dateBetween",
        // filter: (rows, id, e) => rows.filter(t => t.original[id] && moment(t.original[id]).format('DD/MM/YYYY').includes(e)),
        Cell: ({ value }) => value ? moment(value).format('DD/MM/YYYY') : "-",
        hidden: true
      },
      {
        Header: "Date Visite",
        accessor: "DATE_VISITE",
        customExportDisplay: `$.DATE_VISITE ? new Date($.DATE_VISITE) : "-"`,
        Filter: DateRangeColumnFilter,
        filter: "dateBetween",
        // filter: (rows, id, e) => rows.filter(t => t.original[id] && moment(t.original[id]).format('DD/MM/YYYY').includes(e)),
        Cell: ({ value }) => value ? moment(value).format('DD/MM/YYYY') : "-",
        hidden: true
      },
      {
        Header: "Commercial",
        accessor: "COMMERCIAL",
        filter: (rows, id, e) => rows.filter(t => t.original.user?.LOGIN?.toString().toLowerCase().includes((e || "").toLowerCase())),
        Cell: ({ row: {original} }) => original.user?.LOGIN || "-",
        hidden: true
      },
      {
        Header: "Saisie le",
        accessor: "createdAt",
        customExportDisplay: `$.createdAt ? new Date($.createdAt).toLocaleString('fr') : ""`,
        Filter: DateRangeColumnFilter,
        filter: "dateBetween",
        // filter: (rows, id, e) => rows.filter(t => t.original[id] && moment(t.original[id]).format('DD/MM/YYYY').includes(e)),
        Cell: ({ value }) => value ? <div title={moment(value).format('DD/MM/YYYY - HH:mm')}>{moment(value).locale('fr').calendar({
            sameDay: '[Aujourd\'hui à] HH:mm',
            nextDay: 'DD/MM/YYYY à HH:mm',
            nextWeek: 'DD/MM/YYYY à HH:mm',
            lastDay: '[Hier à] HH:mm',
            lastWeek: 'DD/MM/YYYY à HH:mm',
            sameElse: 'DD/MM/YYYY à HH:mm'
        })}</div> : "-",
        hidden: true
      },
      {
        Header: "Observation",
        accessor: "OBSERVATION",
        Cell: ({ value }) => value || "-",
        hidden: true
      },
      {
        Header: "Action",
        className: "text-center",
        Cell: ({ row }) => (
            <Container className="actionsContainer">
                <button className="btn btn-success btn-rounded btn-sm my-0 waves-effect waves-light"
                  onClick={() => {setModalClient(row.original); setModal(true)}}
                  title="Modifier">
                  <FontAwesomeIcon icon={faPen} />
                </button>
                <PDFLink documentType={"client"}
                  data={row.original}
                  download={false}
                  buttonText=""
                  iconSize="inherit"
                  customClassNames="btn btnB btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                  customButtonIcon={faPrint}
                  allowPrintPreview={true}
                  htmlTitle="Imprimer la fiche du client" />
                {row.original.cin_name || row.original.passport_name ? <button className="btn btn-info btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                  onClick={() => (setModalScanClient(row.original), setModalScan(true))}
                  title="Aperçu des Scans">
                  <FontAwesomeIcon icon={faIdCard} />
                </button> : null}
                {/* <button className="btn btn-danger btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                  onClick={() => {setModalDeleteClient(row.original); setModalDelete(true)}}
                  disabled
                  title="Supprimer">
                  <FontAwesomeIcon icon={faTrash} />
                </button> */}
            </Container>
        ),
        disableSortBy: true,
     }
    ],
    []
  );

  return (
    <div>
      <Container>
        <TableContainer columns={columns} data={clientsData} enableCheckBox={false} isEditable={false} SubComponent={({ row }) => <span>SubComponent: {row.id}</span>}/>
      </Container>
      <ClientEdit modal={modal} setModal={setModal} modalClient={modalClient} />
      <ClientDelete modal={modalDelete} setModal={setModalDelete} handleToggle={handleToggleDelete} modalClient={modalDeleteClient} />
      
      <ClientScanModal modal={modalScan} setModal={setModalScan} modalClient={modalScanClient} setModalClient={setModalScanClient} />
      {/* <Modal isOpen={modalScan} toggle={handleToggleScan} onOpened={modalOpenedHandleScan} onClosed={modalClosedHandleScan} className="modal-dialog-large">
        <ModalHeader toggle={handleToggleScan}><FontAwesomeIcon icon={faIdCard} />&nbsp;&nbsp;Aperçu des Scans{modalScanClient && (modalScanClient["CIN"] || modalScanClient["PASSPORT"]) ? (" - " + (modalScanClient["CIN"] || modalScanClient["PASSPORT"])) : ""}</ModalHeader>
        <ModalBody>
          <Container className="scanPreviewContainer">
            {CINImg || CINLoading ? <Row>
              <Col xs="12">CIN</Col>
              <Col xs="12">{CINLoading ? <Loading /> : <img className="scanPreview" src={CINImg}/>}</Col>
            </Row> : null}
            {passportImg || passportLoading ? <Row>
              <Col xs="12">Passeport</Col>
              <Col xs="12">{passportLoading ? <Loading /> : <img className="scanPreview" src={passportImg}/>}</Col>
            </Row> : null}
          </Container>
        </ModalBody>
      </Modal> */}
    </div>
  );
};

const mapStateToProps = (state: IClientTableRedux) => ({
});

export default connect(mapStateToProps, {})(ClientTable);
